import { render } from "./ButtonContainer.vue?vue&type=template&id=bf36a0de&scoped=true"
import script from "./ButtonContainer.vue?vue&type=script&lang=js"
export * from "./ButtonContainer.vue?vue&type=script&lang=js"

import "./ButtonContainer.vue?vue&type=style&index=0&id=bf36a0de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf36a0de"]])

export default __exports__